module.exports = __webpack_public_path__ + "static/media/machine_group_green.068a0134.svg";